'use client'

import { useContext } from 'react'

import { ConversationListContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useBrazeControlCardImpressionLogging } from '@marketplace-web/braze/braze-feature'

const ControlConversationLogger = () => {
  const { controlConversations } = useContext(ConversationListContext)

  useBrazeControlCardImpressionLogging(controlConversations.map(({ id }) => String(id)))

  return null
}

export default ControlConversationLogger
